// START: GitHub Copilot Generated Code
/**
 * Local Content Service
 * Provides immediate access to bundled translation files as fallback content
 * while the API-driven page contents are loading.
 *
 * DRY Principle: Single source of truth for local translation file mappings
 * OWASP Security: No user input involved; only static bundled files are accessed
 * ADA Compliance: Ensures UI renders promptly with localized content
 */

import type { PageContents } from "./contentService";

import translationAR from "../resources/pageContents/translation-AR.json";
import translationEN from "../resources/pageContents/translation-EN.json";
import translationES from "../resources/pageContents/translation-ES.json";
import translationVI from "../resources/pageContents/translation-VI.json";
import translationZH from "../resources/pageContents/translation-ZH.json";

/**
 * Map of language codes to their local translation files.
 * Used as immediate fallback while API content is loading.
 */
const localTranslations: { [language: string]: PageContents } = {
  en: translationEN as unknown as PageContents,
  es: translationES as unknown as PageContents,
  ar: translationAR as unknown as PageContents,
  vi: translationVI as unknown as PageContents,
  zh: translationZH as unknown as PageContents,
};

/**
 * Get local page contents for a given language code synchronously.
 * Returns null if no local translation file exists for the language.
 *
 * @param language - The language code (e.g., 'en', 'es', 'zh', 'ar', 'vi')
 * @returns PageContents from local file or null
 */
export const getLocalPageContents = (language: string): PageContents | null => {
  // OWASP Security: Validate against known keys to prevent object injection
  if (!Object.prototype.hasOwnProperty.call(localTranslations, language)) {
    return null;
  }
  // eslint-disable-next-line security/detect-object-injection
  return localTranslations[language] || null;
};
// END: GitHub Copilot Generated Code
